export default __webpack_public_path__ + "static/media/insta2.738fbd4a.png";